import React from 'react';
import ImmersiveCustomerInfo from '../../layouts/immersive/components/ImmersiveCustomerInfo';
import SimpleCustomerInfo from '../../layouts/centered/components/SimpleCustomerInfo';
import StandardCustomerInfo from '../../layouts/centered/components/StandardCustomerInfo';
import { CustomerInfoType, NodeSettings } from '../../shared/hooks/useCustomerInfo';
import { useLayoutContext } from '../../shared/hooks/useLayoutContext';

export interface CustomerInfoProps {
  customerInfo: CustomerInfoType;
  setCustomerInfo: React.Dispatch<React.SetStateAction<CustomerInfoType>>;
  onNext: () => void;
  onPrev: () => void;
  nodeData?: {
    label: string;
    settings: NodeSettings;
  };
}

const CustomerInfo: React.FC<CustomerInfoProps> = (props) => {
  const { layoutType } = useLayoutContext();

  if (layoutType === 'immersive') {
    return <ImmersiveCustomerInfo {...props} />;
  }

  // Determine which form style to render based on displayStyle setting
  const displayStyle = props.nodeData?.settings?.displayStyle || 'standard';

  // Render the appropriate component based on displayStyle
  if (displayStyle === 'simple') {
    return <SimpleCustomerInfo {...props} />;
  }

  // Default to standard display for any other value
  return <StandardCustomerInfo {...props} />;
};

export default CustomerInfo;
